<div class="relative">
    <h5 mat-dialog-title class="modal_title flex capitalize">
        {{ "CAMPAIGN.IMPORT_MAPPING" | translate }}
        <mat-icon svgIcon="mat_outline:close"
            class="ml-auto max-w-[22px] max-h-[22px] text-[#0b0d13] font-medium cursor-pointer leading-none min-w-[22px] text-[22px] min-h-[22px]"
            mat-dialog-close></mat-icon>
    </h5>
    <mat-dialog-content class="modal_body">
        <div class="">
            <div class="mb-5">
                <h2 class="font-medium text-xl leading-[27px] text-[#0B0D13] mb-1.5 capitalize">
                    {{ "CAMPAIGN.IMPORT_MAPPING" | translate }}
                </h2>
                <p class="text-[#7D7F86] font-normal text-md leading-[18px]">
                    {{ "CAMPAIGN.PLEASE_MATCH_YOUR_COLUMN_NAME" | translate }}
                </p>
            </div>
            <div *ngIf="!mappingData">
                <div class="grid grid-cols-3 gap-x-10">
                    <div *ngFor="let mapping of [1, 2, 3, 4, 5, 6, 7, 8]">
                        <div class="shadow p-4 mb-4">
                            <div>
                                <ngx-skeleton-loader animation="progress" [theme]="{
                                    width: '100px',
                                    height: '20px',
                                    margin: '0px'
                                    }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="">
                                <ngx-skeleton-loader animation="progress" [theme]="{
                                width: '100%',
                                height: '25px',
                                margin: '0px'
                              }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row items-center">
                    <h5 class="mr-3"> <ngx-skeleton-loader animation="progress" [theme]="{
                        width: '20px',
                        height: '20px',
                        margin: '0px'
                        }">
                        </ngx-skeleton-loader></h5>
                    <p class="w-[150px]"><ngx-skeleton-loader animation="progress" [theme]="{
                        width: '150px',
                        height: '20px',
                        margin: '0px'
                        }">
                        </ngx-skeleton-loader></p>
                </div>
            </div>
            <div *ngIf="mappingData">
                <div class="grid grid-cols-3 gap-x-10">
                    <div class="mb-4" *ngFor="let mapping of mappingData?.columns">
                        <div class="w-full">
                            <h5 class="text-[#0B0D13] font-normal text-base leading-[18px] mb-[5px]">{{mapping?.value}}</h5>
                            <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                                <mat-select class="py-1.5" [(ngModel)]="mapping.selectedValue">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            class="[&_.mat-select-search-inner]:shadow-none  [&_.mat-select-search-inner]:p-1 [&_.mat-select-search-inner_.mat-select-search-inner-row]:rounded [&_.mat-select-search-input]:h-[34px] [&_.mat-select-search-clear]:top-1.5 [&_.mat-select-search-clear]:right-2 [&_.mat-select-search-clear]:min-h-8 [&_.mat-select-search-clear]:min-w-8 [&_.mat-select-search-clear]:w-8 [&_.mat-select-search-clear]:h-8 [&_.mat-select-search-clear]:max-h-8 [&_.mat-select-search-clear]:max-w-8 rounded-[5px] [&_.mat-icon]:text-[17px]"
                                            [(ngModel)]="serachMapping"
                                            [placeholderLabel]="'CAMPAIGN.SEARCH_PLACE' | translate"
                                            [noEntriesFoundLabel]="'No results found' | translate"></ngx-mat-select-search>
                                    </mat-option>
                                    <mat-select-trigger class="">
                                        <div class="flex items-center">
                                            <ng-container
                                                *ngIf="mapping?.value == 'default_timezone'; else defaultDisplay">
                                                <span>{{getTimeZoneLabel(mapping?.selectedValue)}}</span>
                                            </ng-container>
                                            <ng-template #defaultDisplay>
                                                <i *ngIf="getSelectedIcon(mapping?.selectedValue)" class="mr-2"
                                                    [class]="getSelectedIcon(mapping?.selectedValue)"></i>
                                                <span>{{getSelectedValue(mapping?.selectedValue) | translate}}</span>
                                            </ng-template>
                                        </div>
                                    </mat-select-trigger>
                                    <mat-option
                                        *ngFor="let item of filterOptions(mapping?.value == 'default_timezone' ? timeZones : mappingField?.mappingKeys, serachMapping, mapping.selectedValue)"
                                        [value]="mapping?.value == 'default_timezone' ? item?.value : item?.key"
                                        class="min-h-[38px] w-full [&_.mdc-list-item\_\_primary-text]:w-full [&_.mdc-list-item\_\_primary-text]:overflow-hidden [&_.mdc-list-item\_\_primary-text]:text-ellipsis" [ngClass]="{'hidden': isOptionSelected(item)}">
                                        <div class="flex items-center">
                                            <i *ngIf="item?.icon" class="mr-2" [class]="item?.icon"></i>
                                            <span>{{mapping?.value == 'default_timezone' ? item?.label : item?.value |
                                                translate}}</span>
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <mat-checkbox class="campaign-checkBox mt-3 -ml-2.5"
                    [(ngModel)]="isCheckDuplicate">{{"CAMPAIGN.CHECK_FOR_DUPLICATE_CAMPAIONS" |
                    translate}}</mat-checkbox>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="start" class="form_action" [ngClass]="{'opacity-50 pointer-events-none': !mappingData}">
        <btn-loading type="submit" color="primary" [loading]="isCheckProspect" (click)="checkDuplicateProspect()"
            btnClass="text-custom text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded"
            [ngClass]="{'pointer-events-none opacity-60': mapping?.isLodingMapping || isCheckProspect}">{{"GENERAL.IMPORT" |
            translate}}</btn-loading>
        <button *ngIf="!isCheckProspect" matRipple class="cancel_btn" mat-dialog-close>{{ "GENERAL.CANCEL" |
            translate
            }}</button>
    </mat-dialog-actions>
</div>

<!-- errorModel -->
<ng-template #errorModel role="document" let-modal>
    <mat-dialog-content class="modal_body">
        <div *ngIf="errNum != 0" class="flex items-center border rounded border-red-700 p-2 mb-4">
            <i class="mdi mdi-alert text-[26px] text-red-700 mr-4"></i>
            <p class="text-[#0B0D13] font-medium text-base leading-6">{{errorMessage}}</p>
        </div>
        <h5 class="text-[#0B0D13] font-semibold text-xl leading-6">{{"GENERAL.ARE_YOU_SURE" | translate}}</h5>
        <p class="text-[#0B0D13] font-medium text-base leading-6">{{"CAMPAIGN.THIS_WILL_UPLOAD" | translate}}
            {{totalProspect}} {{ currentPath.includes('/prospect-management') ?
            ('CAMPAIGN.CONTACT_INTO_YOUR_LIST' | translate) : ('CAMPAIGN.CONTACTS_YOUR_CAMPAIGN' | translate)}}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="start" class="form_action mt-[2px]">
        <btn-loading type="submit" color="primary" (click)="updateProspectMapping()"
            btnClass="text-custom text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded"
            [loading]="mapping?.isLodingMapping" [ngClass]="{'pointer-events-none': mapping?.isLodingMapping}">
            {{"CAMPAIGN.UPLOAD" | translate}}
        </btn-loading>
        <button *ngIf="!mapping?.isLodingMapping" matRipple class="cancel_btn" mat-dialog-close>{{ "GENERAL.CANCEL" |
            translate
            }}</button>
    </mat-dialog-actions>
</ng-template>